export const Px2Rem = (pixelVal: number): string => `${0.0625 * pixelVal}rem`;
